import {IdCodeNameQuery} from "common-shared";

export class ItemListQuery extends IdCodeNameQuery {
  Datasets: string[] = [];
  ItemGroupId: string;
  Group: string;
  TypeClv: string;
  InventoryUnitId: string;
  AssignedTo: string;
  StatusClv: string;
}
